<template>
  <main>
    <!-- Hero section -->
    <div
      class="relative bg-cover bg-center"
      :style="{
        backgroundImage: `url(${require('../assets/images/contact-us.jpg')})`,
      }"
    >
      <div class="absolute inset-0 bg-black bg-opacity-50"></div>
      <div
        class="relative md:px-12 sm:px-12 px-2 max-w-screen-2xl mx-auto z-10 h-[30vh] lg:h-[60vh] flex items-center justify-start text-white"
      >
        <!-- MMC Section -->
        <h1
          class="text-4xl md:text-6xl px-4 lg:px-1 font-bold animate__animated animate__backInLeft"
        >
          Welcome to Mshel Club
        </h1>
      </div>

      <!-- Sleek Arch SVG Curve -->
      <svg
        class="absolute bottom-0 left-0 w-full"
        viewBox="0 0 1440 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="#ffffff"
          d="M0,0 C480,100 960,100 1440,0 L1440,100 L0,100 Z"
        />
      </svg>
    </div>
    <div class="md:px-12 max-w-screen-2xl mx-auto">
      <!-- Hero section implementation -->
      <div
        class="flex flex-col lg:flex-row items-center justify-center space-y-6 lg:space-y-0 lg:space-x-8 py-10"
      >
        <!-- MMC -->
        <div class="w-full lg:w-1/2 flex justify-center">
          <div class="text-center">
            <img
              src="../assets/images/Ellipse 6 (1).png"
              alt="MMC"
              class="object-cover w-2/3 mx-auto"
            />
            <div class="mt-4 md:mb-8">
              <h4 class="text-lg font-bold">Mshel Mentorship Club</h4>
              <router-link
                to="/bum-masterclass"
                class="mt-4 inline-block px-4 py-2 bg-blue text-xl text-white rounded transition-transform transform hover:scale-110 focus:outline-none focus:ring focus:ring-blue-300"
              >
                Register Here
              </router-link>
            </div>
          </div>
        </div>

        <!-- MREM -->
        <div class="w-full lg:w-1/2 flex justify-center">
          <div class="text-center">
            <img
              src="../assets/images/Ellipse 7.png"
              alt="MREC"
              class="object-cover w-2/3 mx-auto"
            />
            <div class="mt-4 md:mb-8">
              <h4 class="text-lg font-bold">Mshel Real Estate Masterclass</h4>
              <router-link
                to="/mrem-masterclass"
                class="mt-4 inline-block px-4 py-2 bg-blue text-xl text-white rounded transition-transform transform hover:scale-110 focus:outline-none focus:ring focus:ring-blue-300"
              >
                Register Here
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- About the Mshel Mentrship club implementation section -->
      <div class="py-12">
        <h4 class="text-center text-lg font-semibold">
          About Mshel Mentorship Club (MMC)
        </h4>
        <p class="mt-6 px-4 lg:px-2">
          Mshel Mentorship Club (MMC) is a community driven initiative dedicated
          to empowering individuals with the tools and guidance needed to
          achieve personal and professional growth. Through mentorship,
          networking, and knowledge-sharing, MMC fosters an environment where
          members can unlock their potential and build meaningful connections.
        </p>
        <p class="px-4 lg:px-2">
          Our mission is to nurture talents, bridge skill gaps, and inspire a
          generation of forward-thinking leaders. By offering tailored programs
          and engaging activities, we ensure every member has access to
          opportunities for learning, collaboration, and self-development.
        </p>
        <p class="px-4 lg:px-2">
          At MMC, we believe in the power of mentorship as a catalyst for
          change. Together, we strive to create a supportive ecosystem that
          values diversity, innovation, and excellence, paving the way for a
          brighter and more inclusive future.
        </p>
      </div>

      <!-- Training Topics Section-->
      <section
        class="container py-32 md:px-12 sm:px-12 px-4 max-w-screen-2xl mx-auto bg-cover bg-center mb-10"
        :style="{
          backgroundImage: `url(${require('../assets/images/hero-section.jpg')})`,
        }"
      >
        <div class="bg-black bg-opacity-50"></div>
        <h1 class="text-lg font-bold lg:text-start text-[#ada595] mb-8 -mt-6">
          Training Topics
        </h1>
        <!-- First Row Trainings -->
        <div class="grid grid-cols-1 md:grid-cols-4 gap-2">
          <!-- Leadership Card -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Leadership
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module on Leadership nurtures essential skills such as
                communication, decision-making, and team management, empowering
                individuals to inspire and guide others effectively.
              </h3>
            </div>
          </div>

          <!-- Financial Management Card -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Financial Management
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module on Financial Management teaches in detail the
                principles of financial budgeting, investment, and risk
                assessment, empowering individuals to make informed decisions
                and achieve long-term financial stability.
              </h3>
            </div>
          </div>

          <!-- Networking Card -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Networking
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                Coaching underscores the significance of networking, teaching
                individuals how to cultivate meaningful connections. Through
                mentorship and guidance, coaching facilitates opportunities for
                professional growth.
              </h3>
            </div>
          </div>

          <!-- Investment & Strategy Planning Card -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Investment & Strategy Planning
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                A module on Investment and Strategy Planning impacts knowledge
                on analyzing markets, identifying opportunities, and developing
                robust plans to achieve financial goals effectively.
              </h3>
            </div>
          </div>
        </div>

        <!-- Second Row Trainings -->
        <div class="grid grid-cols-1 md:grid-cols-4 gap-2 mt-6">
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Business Development & Strategy
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This session on Business Development and strategy equips
                participants with tools and frameworks to identify growth
                opportunities, innovate, and navigate competitive landscapes
                successfully.
              </h3>
            </div>
          </div>

          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Spiritual Formation
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module attempts to explore True Relation with God, being
                Christ centric and creates guidance on spiritual growth, with a
                sense of purpose to life.
              </h3>
            </div>
          </div>

          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Marriage & Parenting
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module explores Marriage and Parenting which provides
                insights and skills to navigate relationships, communication,
                and child mentoring, fostering healthy and fulfilling family
                dynamics.
              </h3>
            </div>
          </div>

          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Wealth Management
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This session on Wealth Management educates individuals on
                investment strategies, financial planning, and risk mitigation
                techniques to achieve long-term financial security and
                prosperity.
              </h3>
            </div>
          </div>
        </div>
      </section>

      <!-- About the Mshel Real Estate Masterclasses section  -->
      <div class="py-12">
        <h4 class="text-center text-lg font-semibold">
          About Mshel Real Estate Masterclass (MREM)
        </h4>
        <p class="mt-6 px-4 lg:px-2">
          The Mshel Real Estate Masterclass (MREM) is a transformative platform
          designed to equip aspiring and seasoned real estate professionals with
          the knowledge, skills, and strategies needed to excel in the dynamic
          real estate market. MREM offers practical insights and actionable
          guidance tailored to various aspects of real estate investment,
          management, and development.
        </p>
        <p class="px-4 lg:px-2">
          Our program is meticulously crafted to bridge the gap between theory
          and practice, providing participants with hands-on learning
          experiences, expert mentorship, and opportunities to network with
          industry leaders. Whether you are looking to start your journey in
          real estate or scale your existing portfolio, MREM empowers you with
          the tools to achieve your goals.
        </p>
        <p class="px-4 lg:px-2">
          At MREM, we are committed to fostering a culture of excellence and
          innovation in real estate. By staying ahead of market trends and
          adopting cutting-edge practices, we ensure our participants remain
          competitive and well-informed, making a lasting impact in the
          industry.
        </p>
      </div>

      <!-- Training Topics Section-->
      <section
        class="container py-32 md:px-12 sm:px-12 px-4 max-w-screen-2xl mx-auto bg-cover bg-center mb-10"
        :style="{
          backgroundImage: `url(${require('../assets/images/hero-section.jpg')})`,
        }"
      >
        <div class="bg-black bg-opacity-50"></div>
        <h1 class="text-lg font-bold lg:text-start text-[#ada595] mb-8 -mt-6">
          Training Topics
        </h1>

        <!-- First Row Trainings -->
        <div class="grid grid-cols-1 md:grid-cols-4 gap-2">
          <!-- Introduction Card -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Introduction To RealEstate
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module offers comprehensive instruction on property
                transactions, investment strategies, and legal considerations,
                preparing students for success in the industry.
              </h3>
            </div>
          </div>

          <!-- Nigeria RealEstate -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Venturing into Nigeria Real Estate System
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module offers opportunities for investment and development
                in a rapidly growing market, with potential for lucrative
                returns.
              </h3>
            </div>
          </div>

          <!-- Real Estate Management -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Real Estate Management & Sustainability Planning
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module helps participants to discover how to create
                environmentally responsible properties while maximizing value
                and long-term impact in the real estate industry.
              </h3>
            </div>
          </div>

          <!-- Investment Strategy and Methodology -->
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Investment Strategy and Methodology
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module helps participants to discover how to create
                environmentally responsible properties while maximizing value
                and long-term impact in the real estate industry.
              </h3>
            </div>
          </div>
        </div>

        <!-- Second Row Trainings -->
        <div class="grid grid-cols-1 md:grid-cols-4 gap-2 mt-6">
          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Real Estate Business Development System
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module on explores Real Estate business development system,
                it equips participants with strategies for market analysis,
                client acquisition, growth management and facilitating success
                in the competitive real estate industry.
              </h3>
            </div>
          </div>

          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Marketing & Branding
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module unveils insights into creating impactful campaigns,
                building Brand identity, and leveraging digital platforms to
                reach target audiences effectively.
              </h3>
            </div>
          </div>

          <div
            class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
          >
            <h3
              class="text-center text-base font-normal mb-3 group-hover:invisible"
            >
              Real Estate Legal System
            </h3>
            <div
              class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
            >
              <h3 class="text-center p-4 font-normal text-sm">
                This module on Real Estate legal system educates participants on
                property laws, contracts, and regulations, ensuring compliance
                and proficiency in navigating legal complexities within the
                industry.
              </h3>
            </div>
          </div>

          <div class="">
            <div
              class="bg-white card group relative hover:bg-blue hover:text-white shadow-lg border border-none px-4 py-16 cursor-pointer flex flex-col items-center justify-center"
            >
              <h3
                class="text-center text-base font-normal mb-3 group-hover:invisible"
              >
                Wealth Management
              </h3>
              <div
                class="absolute inset-0 flex items-center justify-center bg-blue text-white opacity-0 group-hover:opacity-100 transition-opacity"
              >
                <h3 class="text-center p-4 font-normal text-sm">
                  This session on Wealth Management educates individuals on
                  investment strategies, financial planning, and risk mitigation
                  techniques to achieve long-term financial security and
                  prosperity.
                </h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import { RouterLink } from "vue-router";

export default {};
</script>

<style scoped>
.card {
  transition: transform 0.2s ease;
}
.card:hover {
  transform: scale(1.02);
}
svg path {
  fill: #fff !important;
  stroke: none !important;
  box-shadow: none !important;
}

svg {
  overflow: hidden !important;
}

.absolute.bottom-0 {
  line-height: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: -2px;
}

.overflow-hidden {
  overflow: hidden !important;
}
</style>
